import { TreasuryHubWordmark } from '@/shared/components/ui/treasury-hub-logo'
import { useAuth } from '@/shared/lib/auth/auth-context'
import { getUserTenantId } from '@/shared/lib/auth/tenant-constants'
import { useTenantLogo } from '@/shared/lib/branding/use-tenant-logo'

interface TenantBrandLogoProps {
  /** `topbar` is the dark top bar; `sheet` is the light header of the mobile menu. */
  surface: 'topbar' | 'sheet'
}

const LOGO_CLASSES = 'h-10 w-auto max-w-[200px] object-contain'

/** Tenant logo → TreasuryHub wordmark (UC-095, UC-103). */
export function TenantBrandLogo({ surface }: TenantBrandLogoProps) {
  const { user } = useAuth()
  const tenantId = getUserTenantId(user)
  const { logoUrl, isLoading } = useTenantLogo(tenantId)
  const tenantName = user?.tenants.find((tenant) => tenant.id === tenantId)?.name ?? 'Tenant logo'

  if (isLoading) {
    return <span aria-hidden="true" className="block h-10 w-32" />
  }

  if (logoUrl) {
    const logo = <img src={logoUrl} alt={tenantName} className={LOGO_CLASSES} />
    // The logo is designed for a dark background, so the light sheet gets a top-bar strip.
    return surface === 'sheet' ? <div className="rounded-md bg-topbar px-3 py-1.5">{logo}</div> : logo
  }

  return surface === 'topbar' ? (
    <TreasuryHubWordmark height={14} variant="white" />
  ) : (
    <TreasuryHubWordmark height={20} />
  )
}
